import { Component, Inject, Optional } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AppService } from 'src/app/app.service';
import { ShareMenuComponent } from '../../services/share-menu/share-menu.component';

@Component({
  selector: 'app-share-menu-dialog',
  templateUrl: './share-menu-dialog.component.html',
  styleUrls: ['./share-menu-dialog.component.css'],
  standalone: true,
  imports: [TranslateModule, ShareMenuComponent, MatDialogModule],
})
export class ShareMenuDialogComponent {
  appNameIsDemo: boolean;

  constructor(
    @Optional() private dialogRef: MatDialogRef<ShareMenuDialogComponent>,
    @Optional()
    private bottomSheetRef: MatBottomSheetRef<ShareMenuDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any,
    private appService: AppService
  ) {
    this.appNameIsDemo = this.appService.appNameIsDemo();
  }
}
